import Vue from 'vue';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';
import dropsLoader from '@/mixins/components/drops-loader';

export default Vue.component('leave-collab', {
  template: require('./template.html'),
  name: 'leave-collab',
  components: {
    dropsLoader,
  },
  props: [
    'toggle-modal',
    'modal',
  ],
  mixins: [guid],
  computed: {
    ...mapGetters([
      'currentSite',
      'currentUser',
      'websites',
    ]),
  },
  data() {
    return {
      loading: false,
      leaveErrors: false,
      confirmSlider: false,
      loadingOwner: false,
      owner: {},
    };
  },
  watch: {
    modal(open) {
      if (open && !this.owner.email) {
        this.getOwner();
      }
    },
  },
  methods: {
    async getOwner() {
      this.owner = {};
      this.loadingOwner = true;
      try {
        const { name, email } = await this.$lightning([{
          name: 'getCollabSiteOwner',
          payload: {
            siteId: this.currentSite._id,
          },
        }]);
        this.owner = { email, name };
      } catch (e) {
        this.$log.error(e.message || e);
      } finally {
        this.loadingOwner = false;
      }
    },
    async leaveCollab() {
      this.loading = true;
      try {
        const { _id } = this.currentSite;
        await this.$lightning([{
          name: 'leaveCollaboration',
          payload: { siteId: _id },
        }]);
        const { websites } = this.currentUser;
        const idIndex = websites.findIndex(siteId => siteId === _id);
        if (idIndex > -1) {
          this.$store.dispatch('runStateFn', {
            fn() {
              websites.splice(idIndex, 1);
            },
          });
        }
        const globalSites = this.websites;
        const sIndex = globalSites.findIndex(site => site._id === _id);
        if (sIndex > -1) {
          this.$store.dispatch('runStateFn', {
            fn() {
              globalSites.splice(sIndex, 1);
            },
          });
        }
        this.closeModal('collaborators');
        this.confirmSlider = false;
        this.$store.dispatch('addNotification', {
          id: this.guid(),
          type: 'success',
          message: 'Successfully left collaboration!',
        });
        this.$router.push({ path: '/websites' });
      } catch (e) {
        const message = e.message || e;
        this.$log.error(message);
        this.leaveErrors = message;
        await this._reportError({
          error: e,
          fn: 'leaveCollab',
        });
      } finally {
        this.loading = false;
      }
    },
    closeModal(type) {
      this.$emit('toggle-modal', type, 'child');
      this.confirmSlider = false;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/websites/edit-site/leave-collab/index.js